// extracted by mini-css-extract-plugin
export default {"customLoader":"style_customLoader__OpgsQ"};